import { SkeletonTheme } from "react-loading-skeleton";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import {useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../shared/hook";
import { Field, Form, Formik } from "formik";
import style from "../MainScreen/ChequesList.module.css";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import { normalizedLocale } from "../../common/libs/normalizedLocale";
import { useTranslation } from "react-i18next";
import { addItemsToOrder, getProductList } from "../../common/api/ordersApi";
import Pagination from "../../shared/components/Table/Pagination";
import { PaginationState } from "@tanstack/react-table";


function ChequesList() {
  const [errorModal, setErrorModal] = useState(false);
  const [activeTooltipId, setActiveTooltipId] = useState<number | null>(null);
  const handleTooltipToggle = (id: number) => {
    setActiveTooltipId((prevId) => (prevId === id ? null : id));
  };
  const [isComplexSearch, setIsComplexSearch] = useState<boolean>(false)
  const { t, i18n } = useTranslation();
  const locale = normalizedLocale(i18n.language);
  const [sort, setSort] = useState<"ASC" | "DESC">("DESC");
  const navigate = useNavigate();
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
  const { DocumentId } = useParams(); 
  const [cart, setCart] = useState<any[]>([]);
  const [tableData, setTableData] = useState<{
    items: any[];
    count: number;
    numberOfPages: number;
  }>({
    items: [],
    count: 0,
    numberOfPages: 0
  });

  useEffect(() => {
    console.log("UPDATED tableData:", tableData);
  }, [tableData]);

  const handleIncrease = (id: string) => {
    setTableData((prev) => ({
      ...prev,
      items: prev.items.map((item) =>
        item.id == id
          ? { ...item, quantity: Math.min(item.quantity + 1) }
          : item
      )
    }));
  
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === id);
      if (existingItem) {
        return prevCart.map((item) =>
          item.id === id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        const newItem = tableData.items.find((item) => item.id === id);
        return newItem ? [...prevCart, { ...newItem, quantity: 1 }] : prevCart;
      }
    });
  };

  const handleDecrease = (id: string) => {
    setTableData((prev) => ({
      ...prev,
      items: prev.items.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(item.quantity - 1, 0) }
          : item
      )
    }));
  
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === id);
      if (existingItem?.quantity > 1) {
        return prevCart.map((item) =>
          item.id === id ? { ...item, quantity: item.quantity - 1 } : item
        );
      } else {
        return prevCart.filter((item) => item.id !== id);
      }
    });
  };

  const handleQuantityChange = (id: string, newValue: string) => {
    const stock = tableData.items.find((item) => item.id === id)?.stock || 0;
    const quantity = Math.max(0, Math.min(Number(newValue)));
  
    setTableData((prev) => ({
      ...prev,
      items: prev.items.map((item) =>
        item.id === id ? { ...item, quantity } : item
      )
    }));
  
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === id);
      if (existingItem) {
        return prevCart.map((item) =>
          item.id === id ? { ...item, quantity } : item
        );
      } else {
        const newItem = tableData.items.find((item) => item.id === id);
        return newItem ? [...prevCart, { ...newItem, quantity }] : prevCart;
      }
    });
  };

  const transformProducts = (products: any[]): any[] => {
    return products.map((product) => {
      const attrs = Object.fromEntries(
        product.attributes.map((attr:any) => [attr.name, attr.display_value || attr.value || ""])
      );
  
      return {
        id: product.id,
        photo: product.main_photo
          ? `https://new3.articool.online/files-service/api/v1/private/file/${product.main_photo}`
          : "https://png.pngtree.com/png-clipart/20191120/original/pngtree-meal-icon-vectors-png-image_5053746.jpg", // заглушка
        name: attrs["Наименование товара"] || "Без названия", // если поле появится
        barcode: attrs["Штрих-код"] || "—",
        price: attrs["Цена без НДС, тенге"] || 0,
        stock: attrs["Кол-во шт. в блоке"] || 0,
        quantity: 0, // по умолчанию
        type: attrs["Категория/подкатегория"] || "—"
      };
    });
  };
 
  const pageSize = useAppSelector((state) => state.userSettings.pageSize);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await getProductList(pagination.pageIndex + 1, pagination.pageSize);
        const productsList = data.result.productsList;
        const transformed = transformProducts(productsList);
        setTableData({
          items: transformed,
          count: data.result.count,
          numberOfPages: data.result.numberOfPages
        });
      } catch (e) {
        console.error("Ошибка при загрузке данных:", e);
      }
    };

    loadData();
  }, [pagination]);

  useEffect(() => {
    console.log("Обновленный Cart:", cart);
  }, [cart]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.setItem('paginationCheques', JSON.stringify(pagination));
  }, [pagination]);
  interface StatusType {
    type: string;
    label: string;
  }
  useEffect(() => {
    const clearSelected = (e: any) => {
      if (!e.target.classList.contains("react-tooltip")) {
        setIsFilterOpen(false);
      }
    };
    window.addEventListener("click", clearSelected);

    return () => window.removeEventListener("click", clearSelected);
  }, []);


  useEffect(() => {
    onLoad()
  }, [pagination]);

  const debounce = (func: Function, delay: number) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return (...args: any) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  async function onLoad() {

  }

  const toggleSort = () => {
    const newSortDirection = sort === "ASC" ? "DESC" : "ASC";
    setSort(newSortDirection);
  };

  const calculateItemNumber = (index: any) => {
    return pagination.pageIndex * pagination.pageSize + index + 1;
  };
  const statusTypes: { [key: string]: StatusType } = {
    DRAFT: { type: "test", label: t("documentStatus.draft") },
    ERROR: { type: "error", label: t("documentStatus.error") },
    IN_PROCESSING: { type: "test", label: t("documentStatus.in_processing") },
    PROCESSED: { type: "active", label: t("documentStatus.processed") },
    IN_ACCEPTANCE: { type: "test", label: t("documentStatus.in_acceptance") },
    IN_CONFIRMATION: {
      type: "test",
      label: t("documentStatus.in_confirmation"),
    },
    WITHDRAWN: { type: "error", label: t("documentStatus.withdrawn") },
    REJECTED: { type: "error", label: t("documentStatus.rejected") },
    SIGNED_BY_RECIPIENT: {
      type: "active",
      label: t("documentStatus.signed_by_recipient"),
    },
    NOT_PROCESSED: { type: "error", label: t("documentStatus.not_processed") }
  };

  const renderActions = (
    value: any,
    setErrorModal: any,
    navigate: any,
    setAlertOpen?: any,
    setIsCheckOpen?: any,
  ) => {
    const actions = [];
    actions.push({
      title: t("orderList.show"),
      action: () => {
        if (value.status == 'PROCESSED') {
          navigate("/cheque/" + value?.id)
        }

      }
    });
    return actions;
  };
  const [initialValues, setInitialValues] = useState({
    searchTerm: "",
    atribute: []
  });
  //тут будут запросы для полей фильтров



  ;
  // const handleSubmit = () => {
  //   // Получаем текущие данные из куки
  //   const existingData = JSON.parse(localStorage.getItem('TableData') || 'null');



  //   let parsedData = existingData ? existingData : [];
  //   console.log("parsedData", parsedData);

  //   // Обновляем `deliveryDate` только у нужного документа
  //   parsedData = parsedData.map((item: any) =>
  //     item.id == DocumentId ? { ...item, data: [...item.data, ...cart] } : item
  //   );


  //   // Перезаписываем куки
  //   // Cookies.set("TableData", JSON.stringify(parsedData), { secure: true, sameSite: "Strict" });
  //   localStorage.setItem('TableData', JSON.stringify(parsedData));


  //   console.log("Updated TableData:", parsedData);
  // };

  const handleSubmitOrder = async () => {
    try {
      const formattedItems = cart.map(item => ({
        photo: item.photo,
        name: item.name,
        barcode: item.barcode,
        price: item.price,
        stock: item.stock,
        quantity: item.quantity,
        type: item.type,
        editReason: '',
        reductCount: 0,
        returnReason: '',
        returnedQuantity: 0
      }));
      await addItemsToOrder(Number(DocumentId), formattedItems);
  
      console.log("Товары успешно добавлены в заказ");
      setCart([]); // очистка после отправки
    } catch (error) {
      console.error("Ошибка при оформлении заказа", error);
    }
  };
  return (
    < >
      <div className="flex flex-col w-[100%]">

        <div className="flex flex-col w-full">
          <span className="my-3 text-xl font-semibold">
            {t('submenu.receipts')}
          </span>

          <div className="bg-white w-full  my-5 p-5  pt-8 relative rounded-xl shadow-md flex flex-wrap flex-row align-center gap-[20px]">
            <Formik
              initialValues={initialValues}
              onSubmit={() => {
                setPagination((prevValues: PaginationState) => {
                  return { ...prevValues, pageIndex: 0 };
                });
              }}
              // enableReinitialize={true}
              validateOnBlur={true}
              validateOnChange={true}
            // validationSchema={formValidationSchema}

            >
              {(formik) => (
                <Form className="w-full">
                  <div className="flex flex-1 ">
                    <div className="flex flex-row w-full gap-[10px]">

                      <div className="relative  max-w-[500px]">

                        <div className="flex flex-col gap-1 ">

                          <div className="flex  items-center ">
                          </div>
                          <div className="relative ">
                            <img
                              src="/icons/icon-search.svg"
                              alt="Search"
                              className="absolute left-2 top-1/2 transform -translate-y-1/2 w-5 h-5"
                            />
                            <Field
                              type="text"
                              name="searchTerm"
                              placeholder={t("checks.placeholder")}
                              maxLength={150}
                              className=" h-10 border border-mainColor rounded-lg pl-9 text-[#2e3138] outline-none"
                              onKeyDown={(e: React.KeyboardEvent) => {
                                // Запрещаем пробелы и Enter
                                if (e.key === " " || e.key === "Enter") {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e: any) => {
                                formik.handleChange(e);
                                setInitialValues((prevValues: any) => ({
                                  ...prevValues,
                                  searchTerm: e.target.value,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          setIsComplexSearch((prev) => !prev)
                        }
                        }
                        className=" bg-white outline-none text-gray-500 underline flex font-semibold py-2 px-4 rounded min-w-[300px]"
                      >
                        Расширенные настройки
                        <div className="flex flex-col" >
                          {/* <img
                        src={`/icons/arrow${isComplexSearch ? "Down2" : "-top"}.svg`}
                        className={`block h-6 w-6  ${isComplexSearch ? "text-red-500" : ""}`}
                      /> */}
                        </div>
                      </button>
                    </div>
                    <div className="flex justify-between flex-row gap-[10px]">
                      {/* {resendArray.length > 1
                    ? <button
                      type="button"
                      className="bg-mainColor text-white font-semibold py-2 px-4 h-[40px] rounded whitespace-nowrap"
                      onClick={() => {

                      }}
                    >
                      {t("checks.resend_selected_checks")}
                    </button>

                    : null
                  } */}


                      <button
                        type="button"
                        className="bg-bg w-auto text-gray-500 font-semibold py-2 px-4 h-[40px] rounded  whitespace-nowrap"

                        onClick={() => {
                          setInitialValues({
                            atribute: [],
                            searchTerm: ''
                          });
                          formik.resetForm({
                            values: {
                              atribute: [],
                              searchTerm: ''
                            },
                          });
                        }}
                      >
                        {t("checks.clear_filter")}
                      </button>

                      {!DocumentId && (
                        <button
                          onClick={() => navigate('/create')}
                          className=" bg-mainColor text-gray-700 font-semibold py-2 px-4 rounded h-[40px]"
                        >
                          Добавить
                        </button>


                      )}
                      {DocumentId && (
                        <button
                          onClick={() => {
                            handleSubmitOrder();
                            navigate(`/order/${DocumentId}`)
                          }}
                          className=" bg-mainColor text-gray-700 font-semibold py-2 px-4 rounded h-[40px]"
                        >
                          Сохранить
                        </button>
                      )}

                    </div>
                  </div>
                  {isComplexSearch ?
                    <div className="flex flex-wrap w-full gap-[20px] mt-[20px]">


                      <div className={style.inputField}>
                        <div className={style.labelAndButtonWrapper}>
                          <label className={style.inputLabel}>
                            Категория
                          </label>
                        </div>
                        <Field
                          // value={formik?.values?.consumerId || null}
                          component={SelectCustomFormik}
                          name="atribute"
                          isClearable={true}
                          isMulti={true}
                          placeholder={t("checks.choose_receiver")}
                          size="dm"
                          options={[
                            { value: "Газировка", label: "Газировка" },
                            { value: "Шоколад", label: "Шоколад" },
                            { value: "Чипсы", label: "Чипсы" },
                            { value: "Печенье", label: "Печенье" },
                          ]}
                          onChange={(options: any) => {
                            formik.setFieldValue("atribute", options);
                            console.log(initialValues);

                            setInitialValues((prevValues: any) => {
                              return { ...prevValues, atribute: options };
                            });
                          }}
                        />
                      </div>


                    </div>
                    : null
                  }

                </Form>
              )}
            </Formik>
          </div>
          <div className="w-full">
            <div className="rounded-lg bg-white overflow-auto">
              <table className="max-w-full w-full leading-normal">
                <thead className="border-b-2 border-gray-300">
                  <tr>
                    {/* <th
                      className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                      scope="col"
                    >
                      №
                    </th> */}
                    {DocumentId && (
                      <th
                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                        scope="col"
                      >
                        Кол-во
                      </th>
                    )}

                    <th
                      className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                      scope="col"
                    >
                      Фото
                    </th>
                    <th
                      className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                      scope="col"
                    >
                      Наименование товара
                    </th>
                    <th
                      className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                      scope="col"
                    >
                      Штрих-код
                    </th>
                    <th
                      className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                      scope="col"
                    >
                      Категория
                    </th>
                    <th
                      className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                      scope="col"
                    >
                      Цена/шт
                    </th>
                    <th
                      className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                      scope="col"
                    >
                      Кол-во на складе
                    </th>


                  </tr>
                </thead>
                {isLoading ? (
                  <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                    <tbody className="font-normal text-center">

                    </tbody>
                  </SkeletonTheme>
                ) : tableData?.items?.length === 0 || !tableData?.items ? (
                  <tbody>
                    <tr>
                      <td colSpan={8} className="text-center py-5">
                        <div>
                          <EmptyListPlaceholderContent
                            title={t("Товары не найдены")}
                          // description={t("orderList.noOrdersDescription")}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody className="font-normal text-center">
                    {tableData?.items?.map((value: any, index: any) => (
                        <tr
                          key={`tr-${index}-${value.id}`}
                          className="cursor-pointer hover:bg-gray-100"
                        // onClick={() => {
                        //   navigate("/cheque/" + value?.id)
                        // }
                        // }

                        >
                          {/* <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                          {calculateItemNumber(index) || "-"}
                        </td> */}
                        {DocumentId && (

                          <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                            <div className="flex items-center justify-center ">
                              <button
                                onClick={() => handleDecrease(value.id)}
                                className="px-2 py-1 border border-blue-300  text-blue-300 rounded-l-lg hover:bg-blue-100"
                              >
                                −
                              </button>
                              <input
                                type="number"
                                className="w-12 text-center border border-gray-300  h-[30px]"
                                value={value.quantity}
                                min={1}
                                onChange={(e) => handleQuantityChange(value.id, e.target.value)}
                              />
                              <button
                                onClick={() => handleIncrease(value.id)}
                                className="px-2 py-1 border border-blue-300  text-blue-300 rounded-r-lg hover:bg-blue-100"
                              >
                                +
                              </button>
                            </div>
                          </td>
                        )}
                          
                          <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                            {value?.photo ? (
                              <img
                                src={value.photo}
                                alt={value.name}
                                className="w-12 h-12 object-cover rounded-md mx-auto"
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                            {value?.name || "-"}
                          </td>
                          <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                            {/* {format(value?.dateTime, "dd.MM.yyyy") || '-'} */}
                            {value.barcode || ''}
                          </td>
                          <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                            {/* {format(value?.dateTime, "dd.MM.yyyy") || '-'} */}
                            {value.type || ''}
                          </td>
                          <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">

                            {value?.price}
                          </td>
                          <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                            {value?.stock}
                          </td>

                          {value.status == 'PROCESSED' ? (
                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* <ActionDropwdownCell
                          key={`cell-${index}-${value.id}-acitons`}
                          id={value.id}
                          actions={[
                            {
                              title: t("orderList.show"),
                              action: () => {
                                navigate("/cheque/" + value?.id);
                              },
                            },
                          
                          ]}
                        /> */}

                              <ActionDropwdownCell
                                key={index}
                                id={value.id}
                                actions={renderActions(value, setErrorModal, navigate)}
                                activeTooltipId={activeTooltipId}
                                onTooltipToggle={handleTooltipToggle}
                              />
                            </td>
                          ) : (<td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600"
                            onClick={(e) => e.stopPropagation()}
                          >
                          </td>)}

                        </tr>
                      ))}
                  </tbody>
                )}
              </table>
            </div>
            <Pagination
              totalItems={tableData?.count || 0}
              totalPages={tableData?.numberOfPages || 0}
              pagination={pagination}
              setPagination={setPagination}
            />
          </div>
          {/* <div className="z-[1000] relative	">
            <Tooltip
              isOpen={isFilterOpen}
              id="filter-type"
              className={classNames(style.wrapperTooltipFilter, "drop-shadow-2xl")}
              openOnClick={true}
              clickable={true}
              noArrow={true}
              opacity={1}
              place={"bottom-end"}
              afterShow={() => setIsFilterOpen(true)}
              afterHide={() => setIsFilterOpen(false)}
            >
              <div onClick={(e) => e.stopPropagation()}>{renderFilterInputs()}</div>
            </Tooltip>
          </div> */}

        </div>

      </div>

    </>
  );
}


export default ChequesList;
